import { endOfDay, isBefore } from 'date-fns';

import {
  DEFAULT_ORGANIZATION_CATEGORY,
  ORGANIZATION_CATEGORY,
  Organization,
  SupportedOrganizationCategory,
} from '@app/types/organization';

/** 組織区分を取得する。未設定(既存データ)は医療機関として扱う */
export function getOrganizationCategory(
  organization?: Partial<Organization>
): SupportedOrganizationCategory {
  return (
    organization?.customFields?.organizationCategory ??
    DEFAULT_ORGANIZATION_CATEGORY
  );
}

/**
 * 組織区分が人材紹介企業かどうか。
 * 組織そのものを持たない箇所(フォームの入力値や求人にコピーされた区分)から判定する
 */
export function isAgencyCategory(
  category?: SupportedOrganizationCategory
): boolean {
  return (
    (category ?? DEFAULT_ORGANIZATION_CATEGORY) === ORGANIZATION_CATEGORY.AGENCY
  );
}

/**
 * 人材紹介企業かどうか。
 * 人材紹介企業は自組織が勤務先ではないため、求人の勤務先・勤務地情報を手入力させる
 */
export function isAgencyOrg(organization?: Partial<Organization>): boolean {
  return isAgencyCategory(getOrganizationCategory(organization));
}

/**
 * 上限スカウト数が設定されているかどうか。
 * 設定されている場合は有効期限の入力が必須になる。
 * NOTE:入力欄の活性・バリデーション・保存で判定がずれていたため一箇所にまとめる
 */
export function hasScoutLimit(scoutMaxCount?: number | string): boolean {
  return Number(scoutMaxCount ?? 0) > 0;
}

export function getScoutPossibleCount(organization?: Organization): number {
  const {
    scoutMaxCount = 0,
    scoutExpirationDate,
    scoutCount = 0,
  } = organization?.customFields || {};
  const possibleCount = scoutMaxCount - scoutCount;
  // 有効期限チェック
  const isExpiration = scoutExpirationDate
    ? isBefore(new Date(), endOfDay(new Date(scoutExpirationDate)))
    : false;
  return possibleCount > 0 && isExpiration ? possibleCount : 0;
}
